import { Controller } from '@hotwired/stimulus'
import axios from 'axios'
import '@dmuy/toast/dist/mdtoast.css'
import mdtoast from '@dmuy/toast'

export default class extends Controller {
  static targets = [
    'checkbox',
    'label',

  ]

  static values = {
    enabled: { type: Boolean, default: false },
    pageType: { type: String, default: '' },
    organizationId: { type: String, default: '' }
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('client onboarding toggle controller connected.')

    if (this.enabledValue) {
      this.checkboxTarget.checked = true
      this.labelTarget.innerText = "Onboarding Complete"
    }
  }

  disconnect() {
  }

  toggle(evt) {
    evt.preventDefault()

    axios.get(`/organizations/${this.organizationIdValue}/${this.pageTypeValue}_onboarding/toggle`)
      .then((response) => {
        if (response.data.current) {
          this.labelTarget.innerText = "Onboarding Complete"
          mdtoast.success('Onboarding complete.', { duration: 10000 })
        } else {
          this.labelTarget.innerText = "Onboarding Incomplete"
          mdtoast.error('Onboarding incomplete.', { duration: 10000 })
        }
      }).catch((error) => {
        console.log(error)
      })
  }
}
